<template>
  <div class="input-wrapper">
    <input
      v-model="text"
      type="text"
      class="reset-input"
      :class="{ 'focused': isFocused }"
      :placeholder="placeholder"
      @focus="isFocused = true"
      @blur="onBlur"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Click to edit',
    },
  },
  data() {
    return {
      text: this.value,
      isFocused: false,
    };
  },
  created() {
    this.text = this.value;
  },
  methods: {
    onBlur() {
      this.isFocused = false;
      this.$emit('input', this.text);
    },
  },
};
</script>

<style scoped>
.reset-input {
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  box-shadow: none;
  appearance: none;
  font: inherit;
  color: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-transform: inherit;
  line-height: inherit;
  word-spacing: inherit;
  direction: inherit;
  resize: none;
  text-align: right;
  cursor: pointer;
}

.focused {
  padding: 0 0.5rem;
  border: 2px solid var(--primary-bg);
  border-radius: 0.25rem;
}
</style>
